import ComposeViewState from '../store/schema/ComposeViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'clearKeysOfInternetHeadersToBeRemoved',
    (viewState: ComposeViewState) => {
        viewState.keysOfInternetHeadersToBeRemoved = [];
    }
);
